import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import MembershipListServices from '../../services/MembershipListServices';

function AddMembership() {
  const navigate = useNavigate();
      const [imagePreview, setImagePreview] = useState([]);
  const [formValues, setFormValues] = useState({
    categoryId: '',
    name: '',
    price: '',
    offer: '',
    self_subsription_bonus:"",
    refer_subscription_bonus:"",
    endDate: '',
    durationDays: '',
    description: '',
    maxOrdersPerDay: '',
    maxDiscountPerOrder: '',
    discountPercent: '',
     image: null,
  });
  const [services, setServices] = useState([]);
  useEffect(() => {
    fetchDropdownData();
  }, []);
  useEffect(() => {
    setFormValues(prev => ({
      ...prev,
      endDate: '',
      durationDays: ''
    }));
  }, [formValues.categoryId]);
  const fetchDropdownData = async () => {
    try {
      const categoryRes = await MembershipListServices.getMembershipCategory();
      const categoryData = categoryRes?.data || [];
      const formattedServices = categoryData
        .filter(item => item.name)
        .map(item => ({
          _id: item._id,
          name: item.name
        }));

      setServices(formattedServices);

      console.log("MembershipCategory:", formattedServices);

    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    }
  };
const handleImageChange = (e) => {
  const files = Array.from(e.target.files || []);
  if (!files.length) return;

  // single image hai to first file use karo, warna saari
  const file = files[0];

  setFormValues((prev) => ({
    ...prev,
    image: file,
  }));

  setImagePreview([URL.createObjectURL(file)]);   // array mein wrap karo
};
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value
    });
  };

  const handleNumberInput = (e) => {
    if (['e', 'E', '+', '-', '.'].includes(e.key)) {
      e.preventDefault();
    }
  };

  const handleNumberPaste = (e) => {
    const pasteData = e.clipboardData.getData('text');
    if (!/^\d+$/.test(pasteData)) {
      e.preventDefault();
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {

      // const payload = {
      //   categoryId: formValues.categoryId,
      //   name: formValues.name,
      //   price: Number(formValues.price),
      //   durationDays: Number(formValues.durationDays),
      //   description: formValues.description,
      //   maxOrdersPerDay: Number(formValues.maxOrdersPerDay),
      //   maxDiscountPerOrder: Number(formValues.maxDiscountPerOrder),
      //   discountPercent: Number(formValues.discountPercent),
      //   offer_price: Number(formValues.offer),
      //   self_subscription_bonus: Number(formValues.self_subsription_bonus),
      //   referral_subscription_bonus: Number(formValues.refer_subscription_bonus),
      //   // endDate: formValues.endDate
      //   ...(isPremium && { endDate: formValues.endDate }),
      //   ...(isPrime && { durationDays: Number(formValues.durationDays) })
      // };


 const formData = new FormData();

    // Helper: only append non-empty values
    const appendIf = (key, value, isNumber = false) => {
      if (value !== undefined && value !== null && value !== '') {
        formData.append(key, isNumber ? Number(value) : value);
      }
    };

    // ── Always send ──
    appendIf('categoryId', formValues.categoryId);
    appendIf('name', formValues.name);
    appendIf('price', formValues.price, true);
    appendIf('durationDays', formValues.durationDays, true);
    appendIf('description', formValues.description);
    appendIf('maxOrdersPerDay', formValues.maxOrdersPerDay, true);
    appendIf('maxDiscountPerOrder', formValues.maxDiscountPerOrder, true);
    appendIf('discountPercent', formValues.discountPercent, true);
    appendIf('offer_price', formValues.offer, true);
    appendIf('self_subscription_bonus', formValues.self_subsription_bonus, true);
    appendIf('referral_subscription_bonus', formValues.refer_subscription_bonus, true);

    // ── Conditional (same as your payload spread) ──
    if (isPremium) appendIf('endDate', formValues.endDate);
    if (isPrime) appendIf('durationDays', formValues.durationDays, true);

    // ── Image ──
    if (formValues.image) {
      formData.append('image', formValues.image);
    }



      await MembershipListServices.createMembership(formData);
      alert('Membership created successfully');
      navigate('/membership-list');

    } catch (error) {
      console.error('Failed to create Membership', error);
      alert('Failed to create Membership');
    }
  };
  // ✅ selected category find karo
  const selectedCategory = services.find(
    (item) => item._id === formValues.categoryId
  );

  const categoryName = selectedCategory?.name;
  // const categoryName = selectedCategory?._id;

  // const isPremium = categoryName === "platinum";
  // const isPrime = categoryName === "prime";
  const isPremium = categoryName === "PLATINUM";
  const isPrime = categoryName === "PRIME";
  return (
    <>
      <div className="right_col" role="main">
        <div className="d-md-flex align-items-center justify-content-between my-4 page-header-breadcrumb">
          <div className="my-auto">
            <h5 className="page-title fs-21 mb-1">Membership Add</h5>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript:void(0);">Home</a>
                </li>
                <li className="breadcrumb-item active">Membership</li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
            <div className="pe-1 mb-xl-0">
              <Link className="list-banner-btn" to="/membership-list"> Membership List</Link>
            </div>
          </div>
        </div>

        <div className="container-box">
          <div className="container-box-inner table-reponsive-tabe">
            <div className="page-details">
              <form onSubmit={handleSubmit}>

                {/* ✅ Membership Category Dropdown */}
                <div className="input-field">
                  <label>Select Membership Category *</label>
                  <select
                    name="categoryId"
                    value={formValues.categoryId}
                    onChange={handleInputChange}
                    className="form-control"
                    
                  >
                    <option value="">Select Membership Category</option>
                    {services.map(service => (
                      <option key={service._id} value={service._id}>
                        {service.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div>



                  <div className="input-field">
                    <label>Name<span className="red">*</span></label>
                    <input
                      type="text"
                      name="name"
                      value={formValues.name}
                      onChange={handleInputChange}
                      className="form-control"
                      
                      placeholder='New Name'
                    />
                  </div>
                  {isPremium && (
                    <div className="input-field">
                      <label>End Date<span className="red">*</span></label>
                      <input
                        type="date"
                        name="endDate"
                        value={formValues.endDate}
                        onChange={handleInputChange}
                        className="form-control"
                        
                      />
                    </div>
                  )}
                </div>
                <div className="input-field">
                  <label>Price<span className="red">*</span></label>
                  <input
                    type="number"
                    name="price"
                    value={formValues.price}
                    onChange={handleInputChange}
                    onKeyDown={handleNumberInput}
                    onPaste={handleNumberPaste}
                    className="form-control"
                    
                    placeholder='New Price'
                  />
                </div>
                <div className="input-field">
                  <label>Offer Price<span className=""></span></label>
                  <input
                    type="number"
                    name="offer"
                    value={formValues.offer}
                    onChange={handleInputChange}
                    onKeyDown={handleNumberInput}
                    onPaste={handleNumberPaste}
                    className="form-control"
                    placeholder='Enter Offer'
                  />
                </div>
                <div className="input-field">
                  <label>Self Subscription Bonus<span className=""></span></label>
                  <input
                    type="number"
                    name="self_subsription_bonus"
                    value={formValues.self_subsription_bonus}
                    onChange={handleInputChange}
                    onKeyDown={handleNumberInput}
                    onPaste={handleNumberPaste}
                    className="form-control"
                    placeholder='Enter Offer'
                  />
                </div>
                <div className="input-field">
                  <label>Refer Subsription Bonus<span className=""></span></label>
                  <input
                    type="number"
                    name="refer_subscription_bonus"
                    value={formValues.refer_subscription_bonus}
                    onChange={handleInputChange}
                    onKeyDown={handleNumberInput}
                    onPaste={handleNumberPaste}
                    className="form-control"
                    placeholder='Enter Offer'
                  />
                </div>

                {isPrime && (
                  <div className="input-field">
                    <label>Duration Days<span className="red">*</span></label>
                    <input
                      type="number"
                      name="durationDays"
                      value={formValues.durationDays}
                      onChange={handleInputChange}
                      onKeyDown={handleNumberInput}
                      onPaste={handleNumberPaste}
                      className="form-control"
                      
                    />
                  </div>
                )}

                <div className="input-field">
                  <label>Description<span className="red">*</span></label>
                  <textarea
                    name="description"
                    value={formValues.description}
                    onChange={handleInputChange}
                    className="form-control"
                    
                    placeholder="Enter Description"
                    style={{ height: "100px" }}
                  />
                </div>
  <div className="col-lg-6 mt-3">
                            <label>Images </label>
                            <input
                                type="file"
                                // multiple
                                className="form-control"
                                onChange={handleImageChange}
                                // disabled={uploadingImages}
                                accept="image/*"
                            />
                            {/* {uploadingImages && <p className="text-muted mt-1">Uploading images...</p>} */}

                            {/* Preview Multiple Images */}
                            {imagePreview.length > 0 && (
                                <div className="mt-2" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                                    {imagePreview.map((img, index) => (
                                        <div key={index} className="position-relative d-inline-block">
                                            <img
                                                // src={`${process.env.REACT_APP_URL}${img}`}
                                                src={img}
                                                width="80"
                                                height="80"
                                                style={{ objectFit: 'cover', borderRadius: '4px' }}
                                                alt={`Preview ${index + 1}`}
                                            />
                                            {/* <button
                                                type="button"
                                                // onClick={() => removeImage(img)}
                                                className="btn btn-danger btn-sm"
                                                style={{ position: 'absolute', top: '-8px', right: '-8px', borderRadius: '50%', padding: '2px 6px' }}
                                            >
                                                ×
                                            </button> */}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                {/* <div className="input-field">
                  <label>Max Orders Per Day<span className="red">*</span></label>
                  <input
                    type="number"
                    name="maxOrdersPerDay"
                    value={formValues.maxOrdersPerDay}
                    onChange={handleInputChange}
                    onKeyDown={handleNumberInput}
                    onPaste={handleNumberPaste}
                    className="form-control"
                 
                    placeholder='New Max Orders Per Day'
                  />
                </div> */}

                {/* <div className="input-field">
                  <label>Max Discount Per Order<span className="red">*</span></label>
                  <input
                    type="number"
                    name="maxDiscountPerOrder"
                    value={formValues.maxDiscountPerOrder}
                    onChange={handleInputChange}
                    onKeyDown={handleNumberInput}
                    onPaste={handleNumberPaste}
                    className="form-control"
             
                    placeholder='New Max Discount Per Order'
                  />
                </div> */}

                {/* <div className="input-field">
                  <label>Discount Percent<span className="red">*</span></label>
                  <input
                    type="number"
                    name="discountPercent"
                    value={formValues.discountPercent}
                    onChange={handleInputChange}
                    onKeyDown={handleNumberInput}
                    onPaste={handleNumberPaste}
                    className="form-control"
                  
                    placeholder='New Discount Percent'
                  />
                </div> */}

                <button className="submit-green-btn">SUBMIT</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AddMembership